import React, { useEffect, useState } from 'react';
import Utils from './utils.js';
import Fetch from './fetch.js';
import { Button } from '@wordpress/components';
import { Flex, FlexBlock, FlexItem } from '@wordpress/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faPalette } from '@fortawesome/free-solid-svg-icons'
import { Modal } from "react-bootstrap";
import ColorControl from './ColorControl.js'
import ColorName from './ColorName'
import ColorSlug from './ColorSlug'

function ColorPalette() {

    const [colorPalette, setPalette] = useState([]);
    useEffect(() => {
        async function loadPalette() {
            const response = await fetch('/wp-json/davenport/v1/palette');
            if(!response.ok) {
                return;
            }
    
            const palette = await response.json();
            setPalette(palette);
        }
    
        loadPalette();
        
    }, [])
    
    const newColor = () => {
        setPalette([...colorPalette, {color:"#000000",name:"Black",slug:"black"}])
    }

    const [color, handleColorChange] = useState({idx:0,color:''})
    const [name, handleNameChange] = useState({idx:0,name:''})

    colorPalette.map((paletteColor, index) => {
        //update with child control states
        if(color.color != '' && color.idx == index){
            paletteColor.color = color.color
        }
        if(name.name != '' && name.idx == index){
            paletteColor.name = name.name
            paletteColor.slug = Utils.kebabCase(name.name," ")
        }

    })

    const deleteColor = ( event, index ) => {
        colorPalette.splice(index, 1);
        setPalette([...colorPalette])
    }

    const saveColorPalette = ( event ) => {
        const inputs = JSON.stringify(colorPalette)
        let params = {
			url : DBD.api_palette.url,
			nonce : DBD.api_palette.nonce,
			action : 'save_palette',
			data : inputs,
		};
			
        let noticeContainer = document.querySelector('.davenport-theme-options-notice');
		Fetch.send(params,function(message){
            Utils.setNotice(noticeContainer,message);
            localStorage.setItem('active-tab','color-palette');
            location.reload();
        });
    }

    const [ state, setState] = useState({showModal:false});
    const showModal = () => setState( {showModal:true} );
    const hideModal = () => setState( {showModal:false} );
    const MyModal = (props) => (<Modal show={props.isHidden} onHide={props.onClose}>
        <Modal.Header>
            <Modal.Title>CSS Root Variables</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {colorPalette && colorPalette.map((paletteColor, index) => (
                <div key={index}>
                    --{paletteColor.slug}:{paletteColor.color};
                </div>
            ))}
            <hr />
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={props.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );

    return (
        <form>
            {colorPalette && colorPalette.map((paletteColor, index) => (

                <Flex expanded="true" gap="30px" key={index}>
                    <FlexItem className="dbd-color-picker">
                        <ColorControl 
                            color={(color.color != '' && color.idx == index)? color.color : paletteColor.color} 
                            idx={index}
                            handleColorChange={handleColorChange}
                        />
                    </FlexItem>
                    <FlexItem>
                        <ColorName 
                            name={
                                //(color.fn != '' && color.idx == index ? color.fn :
                                (name.name != '' && name.idx == index) ? name.name : 
                                paletteColor.name
                            } 
                            idx={index}
                            handleNameChange={handleNameChange} 
                        />
                    </FlexItem>
                    <FlexItem>
                        <ColorSlug 
                            idx={index}
                            slug={paletteColor.slug} 
                            inputValue={name} 
                        />
                    </FlexItem>
                    <FlexItem>
                        <FontAwesomeIcon 
                            icon={faTrash} 
                            size="sm" 
                            className="delete_color"
                            onClick={(e) => {deleteColor(e,index)}}
                        />
                    </FlexItem>
                </Flex>
            ))}

            <div className="color-palette-btns" style={{padding:'30px'}}>
                <Button className="btn btn-primary med" onClick={newColor}>
                    New Color <FontAwesomeIcon icon={faCirclePlus} />
                </Button>
                <Button 
                    className="btn btn-primary save-color-palette" 
                    onClick={(e) => {saveColorPalette(e)}}
                >
                    Save
                </Button>
                <MyModal isHidden={state.showModal} onClose={hideModal} />
                <Button className="btn btn-primary lg" id="get_cp_vars" onClick={showModal} style={{"float":"right"}}>
                    Get Root Variables <FontAwesomeIcon icon={faPalette} />
                </Button>
            </div>
        </form>
    )

}
export default ColorPalette
